<template>
  <div class="nix-reset-form">
    <Messages />

    <div v-if="!showSuccess">
      <div class="nix-reset-form__title">Redefinir Senha</div>

      <div class="nix-reset-form__fields">
        <InputPassword
          v-model="forgot.password"
          title="Nova Senha"
          field="password"
          :formName="formName"
          :required="true"
          :maxLength="50"
        >
          <div class="glyphicon"><i class="fas fa-lock"></i></div>
        </InputPassword>

        <InputPassword
          v-model="forgot.confirmPassword"
          title="Confirme Nova Senha"
          field="confirmPassword"
          :formName="formName"
          :required="true"
          :maxLength="50"
        >
          <div class="glyphicon"><i class="fas fa-lock"></i></div>
        </InputPassword>
      </div>

      <div class="nix-reset-form__btn">
        <Button
          _key="save"
          type="success"
          title="Salvar"
          classIcon="fa-solid fa-floppy-disk"
          size="medium"
          :disabled="disabled"
          :clicked="save"
        />
      </div>

      <div class="nix-reset-form__link" @click="navegateToLogin">
        Voltar para o login
      </div>
    </div>

    <div class="text-center" v-else>
      <div class="nix-reset-form__success-title">Senha redefinida com sucesso!</div>
      <div class="nix-reset-form__success-icon">
        <i class="fa-light fa-circle-check"></i>
      </div>
      <Timer :title="'Redirecionando para o Login em'" :initialTimer="5" :endTime="navegateToLogin" />
    </div>
  </div>
</template>

<script>
import InputPassword from '@/ui/forms/InputPassword.vue'
import Button from '@/ui/forms/Button.vue'
import Messages from '@/ui/shared/Messages.vue'
import Timer from '@/ui/shared/Timer.vue'
import ForgotPassword from '@/modules/auth/models/forgot-password'
import { authService } from '@/modules/auth/services/auth.service'
import { mapMutations } from 'vuex'

export default {
  name: 'ResetPasswordForm',
  components: { InputPassword, Button, Messages, Timer },
  data() {
    return {
      formName: 'forgot',
      forgot: new ForgotPassword(),
      showSuccess: false,
    }
  },
  computed: {
    disabled() {
      return !(this.forgot.password && this.forgot.password == this.forgot.confirmPassword)
    },
  },
  methods: {
    ...mapMutations('generic', ['removeLoading']),
    async save() {
      try {
        await authService.resetPassword({
          codeResetPassword: this.$route.params.code,
          password: this.forgot.password,
        })
        this.showSuccess = true
      } catch (e) {
        // erros já são exibidos pelo Messages
      } finally {
        this.removeLoading(['save'])
      }
    },
    navegateToLogin() {
      this.$router.replace(this.$route.query.redirect || '/login')
    },
  },
}
</script>

<style scoped>
.nix-reset-form {
  padding: 20px 20px 30px;
}

.nix-reset-form__title {
  margin-bottom: 30px;
  font-size: 25px;
  color: var(--text-primary);
}

.nix-reset-form__fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nix-reset-form__btn {
  margin-top: 20px;
}

.nix-reset-form__link {
  margin-top: 15px;
  margin-bottom: 5px;
  text-align: center;
  cursor: pointer;
  color: var(--color-brand);
}

.nix-reset-form__link:hover {
  color: var(--color-brand-hover);
  text-decoration: underline;
}

.nix-reset-form__success-title {
  margin-bottom: 25px;
  font-size: 18px;
  color: var(--text-primary);
}

.nix-reset-form__success-icon i {
  margin-bottom: 15px;
  font-size: 50px;
  color: #16a34a;
}

.glyphicon {
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  top: 50%;
  padding-top: 0;
  transform: translateY(-50%);
}
</style>
